import { createInputs } from '../../utils';

export default createInputs([]);
